"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schedTxViewsWindows = exports.schedTxViewsMac = exports.schedTxViews = exports.visibleBalances = exports.AccountBalances = void 0;
const immutable_1 = require("immutable");
exports.AccountBalances = (0, immutable_1.Record)({
    accountId: null,
    accountType: null,
    currentBalance: null,
    onlineBalance: null,
    endingBalance: null,
    endingBalanceNoRecurring: null,
    finalBalance: null,
    goalsBalance: null,
    earliestTransactionDate: null,
    txnsDeltaFromCurrentBalance: null,
    cpOnlineBalance: undefined,
    cpAvailableBalance: undefined,
    defaultBalance: undefined,
});
exports.visibleBalances = [
    { label: "Today's Balance", key: 'sumCurrentAccountBalances', value: 'today' },
    { label: 'Online Balance', key: 'sumOnlineAccountBalances', value: 'online' },
    { label: 'Projected Balance', key: 'sumEndingAccountBalances', value: 'ending' },
];
exports.schedTxViews = [
    { label: 'Next 7 Days', value: '7' },
    { label: 'Next 14 Days', value: '14' },
    { label: 'Next 30 Days', value: '30' },
    { label: 'Next 90 Days', value: '90' },
    { label: 'Next 12 months', value: '365' },
    { label: "Don't show reminders", value: '0' },
];
exports.schedTxViewsMac = [
    { label: 'Next 7 Days', value: '7' },
    { label: 'Next 14 Days', value: '14' },
    { label: 'Next 30 Days', value: '30' },
    { label: 'Next 90 Days', value: '90' },
    { label: 'Next 6 months', value: '182' },
    { label: 'Next 12 months', value: '365' },
    { label: 'The next upcoming occurrence', value: '-1' },
    { label: "Don't show reminders", value: '0' },
];
exports.schedTxViewsWindows = [
    { label: 'Next 7 Days', value: '7' },
    { label: 'Next 14 Days', value: '14' },
    { label: 'Next 30 Days', value: '30' },
    { label: 'Next 90 Days', value: '90' },
    { label: 'Next 12 months', value: '365' },
    { label: "Don't show reminders", value: '0' },
];
